import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'links/plano-pluri-anual',
		component: Base,
		children: [
			{
				path: '',
				name: 'PlanoPluriAnualList',
				component: List,
				meta: {
					path: '/links/plano-pluri-anual',
					pai: 'Links',
					title: 'Admin - Plano Pluri Anual',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Plano Pluri Anual',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PlanoPluriAnualNovo',
				component: Form,
				meta: {
					path: '/links/plano-pluri-anual',
					pai: 'Links',
					title: 'Admin - Plano Pluri Anual - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Plano Pluri Anual',
						class: '',
						active: false,
						url: '/links/plano-pluri-anual'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PlanoPluriAnualEditar',
				component: Form,
				meta: {
					path: '/links/plano-pluri-anual',
					pai: 'Links',
					title: 'Admin - Plano Pluri Anual - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Plano Pluri Anual',
						class: '',
						active: false,
						url: '/links/plano-pluri-anual'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]